import React from "react";

import "./FormSidebar.scss";

interface FormSidebarMenuProps {
  sidebarList: {
    label: string;
    menus: {
      menu: string;
      tab: string;
      icon: any;
    }[];
  }[];
  activeTabName: string;
  setActiveTabName: any;
}

export default function FormSidebar({
  sidebarList,
  activeTabName,
  setActiveTabName,
}: FormSidebarMenuProps) {
  return (
    <section className="form-sidebar">
      {sidebarList.map((item, i) => {
        return (
          <div className="main-menu" key={i}>
            {item.label && <li>{item.label}</li>}
            <ul className="sub-menu">
              {item.menus.map((subMenu, j) => {
                return (
                  <li
                    key={i + "" + j}
                    className={activeTabName === subMenu.tab ? "active" : ""}
                    onClick={() => setActiveTabName(subMenu.tab)}
                  >
                    {subMenu.icon}
                    {subMenu.menu}
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </section>
  );
}
